import { Modal } from "react-bootstrap";
import HelperService from "../../../Services/HelperService";

interface CommonModalProps {
  show: boolean;
  handleClose: () => void;
  title: string;
  url: string;

}

const CommonModal = ({ show, handleClose, title, url }: CommonModalProps) => {
  if (!url) return null;

  // const lowerUrl = fileTitle?.toLowerCase();
  // const isPdf = lowerUrl?.endsWith(".pdf");
  // const isImage =
  //   lowerUrl?.endsWith(".jpg") ||
  //   lowerUrl?.endsWith(".jpeg") ||
  //   lowerUrl?.endsWith(".png") ||
  //   lowerUrl?.endsWith(".gif") ||
  //   lowerUrl?.endsWith(".webp");
  // const isVideo =
  //   lowerUrl?.endsWith(".mp4") ||
  //   lowerUrl?.endsWith(".mov") ||
  //   lowerUrl?.endsWith(".avi") ||
  //   lowerUrl?.endsWith(".mkv");

  return (
    <Modal show={show} onHide={handleClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>{title && HelperService.titleCase(title) || "View Image"}</Modal.Title>
      </Modal.Header>
      <Modal.Body
        style={{
          height: "80vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* {isPdf ? (

          <div style={{ width: "100%", height: "75vh", overflow: "hidden" }}>
            <iframe
              src={url}
              title="PDF Viewer"
              style={{
                border: "none",
                width: "100%",
                height: "100%",
              }}
            />
          </div>

        ) : isImage ? ( */}
        <img
          src={url}
          alt={title || "Preview"}
          style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
        />
        {/* ) : isVideo ? (
          <video
            src={url}
            controls
            style={{ maxWidth: "100%", maxHeight: "100%" }}
          />
        ) : (
          <p>Unsupported file type</p>
        )} */}
      </Modal.Body>
    </Modal>
  );
};

export default CommonModal;
